import Title from '../../shared/components/Title/Title';
import Greeting from '../../shared/components/Greeting/Greeting';
import ChannelSelector from '../../shared/components/ChannelSelector/ChannelSelector';

import OpportunitiesNav from './OpportunitiesNav';

const OpportunitiesHeader = () => (
	<>
		<div className="flex justify-between">
			<Title>Opportunities</Title>
			<ChannelSelector />
		</div>
		<div className="my-2">
			<Greeting />
		</div>
		<div className="mt-6">
			<OpportunitiesNav />
		</div>
	</>
);

export default OpportunitiesHeader;
